<h2 class="page-title">Search for supplier</h2>

<div class="card-section">
  <form (submit)="search()" class="d-flex gap-2">
    <input type="text" class="form-control" [(ngModel)]="searchQuery"
      placeholder="Enter supplier name..." name="searchQuery">
    <button type="submit" class="btn btn-primary">Search</button>
  </form>
  <div id="load_status" class="status-text mt-2">&nbsp;</div>
</div>

@if (searchResults.length > 0) {
  <div class="card-section">
    <table class="table table-hover mb-0">
      <thead>
        <tr>
          <th>Supplier Name</th>
          <th>URL</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        @for (result of searchResults; track result) {
          <tr>
            <td>{{ result.name }}</td>
            <td>{{ result.url }}</td>
            <td>
              <button class="btn btn-sm btn-outline-primary"
                (click)="create_or_load_implementation(result.id)">
                Create / Load
              </button>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}

@if (searchResults.length === 0) {
  <p class="status-text">No results found.</p>
}
